<div class="container">
  <h1 mat-dialog-title>{{title}}</h1>
  <div mat-dialog-content>
      <table class="list-table">
        <tr>
          <th class="secondary"><label>Date</label></th>
          <th><label>Old value</label></th>
          <th><label>User</label></th>
          <th><label>IP</label></th>
        </tr>
        <tr *ngFor="let log of list">
          <td class="secondary"><label>{{ log.date | date: "dd.MM.yyyy HH:mm" }}</label></td>
          <td><label>{{ log.oldValue }}</label></td>
          <td><label>{{ log.userFullName }}</label></td>
          <td><label>{{ log.ipAddress }}</label></td>
        </tr>
      </table>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button (click)="onOkClick()" color="primary">Ok</button>
  </div>
</div>